/**
 * ZZ Media Grid — Varianten-Frames (Stop-Motion-/Crossfade-Effekt).
 * Schaltet die Frames in [data-zz-vframes] durch:
 * - nur solange die Kachel sichtbar ist (IntersectionObserver)
 * - erst wenn alle Frame-Bilder geladen sind (kein Ruckeln im 1. Durchlauf)
 * - gar nicht bei prefers-reduced-motion (erster Frame bleibt stehen)
 */
(function () {
  if (window.zzVframesLoaded) return;
  window.zzVframesLoaded = true;
  if (!('IntersectionObserver' in window)) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(el) {
    if (el.dataset.zzInit) return;
    el.dataset.zzInit = 'true';

    const frames = Array.from(el.querySelectorAll('.zz-vframe'));
    if (frames.length < 2 || reduced.matches) return;

    const interval = Math.max(parseInt(el.dataset.interval, 10) || 800, 150);
    const imgs = frames.map((f) => f.querySelector('img')).filter(Boolean);
    let idx = 0;
    let timer = null;
    let visible = false;

    const ready = () => imgs.every((img) => img.complete && img.naturalWidth > 0);

    const tick = () => {
      frames[idx].classList.remove('is-active');
      idx = (idx + 1) % frames.length;
      frames[idx].classList.add('is-active');
    };

    const start = () => {
      if (!timer && visible && ready()) timer = setInterval(tick, interval);
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };

    // Nachzügler-Bilder: sobald geladen, Start erneut versuchen
    imgs.forEach((img) => {
      if (!img.complete) img.addEventListener('load', start, { once: true });
    });

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        visible = entry.isIntersecting;
        if (visible) start();
        else stop();
      });
    }, { rootMargin: '50px' }).observe(el);
  }

  const initAll = (root) => root.querySelectorAll('[data-zz-vframes]').forEach(setup);

  initAll(document);

  // Theme-Editor: Section wird neu gerendert
  document.addEventListener('shopify:section:load', (evt) => initAll(evt.target));
})();
